import {
  Accordion as MUIAccordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
interface IAccordionProps {
  title: string;
  content: JSX.Element;
  className?: string;
}

const Accordion = ({ title, content, className }: IAccordionProps) => {
  React.useEffect(() => {}, []);

  return (
    <div className="w-auto max-w-full">
      <MUIAccordion className={`max-w-min ${className}`}>
        <AccordionSummary className="whitespace-nowrap" expandIcon={<ExpandMoreIcon fontSize="small" />}>
          {title}
        </AccordionSummary>
        <AccordionDetails>{content}</AccordionDetails>
      </MUIAccordion>
    </div>
  );
};

export default Accordion;
